import { DefaultValidator } from '../'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'

const defaultTranslateKey = 'validator.validAgency'

export const validAgency = value => value > 0

export const validAgencyTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(validAgency, localeKey || defaultTranslateKey),
)
